<template>
    <v-container fill-height>
        <v-layout row align-center justify-center>
            <v-flex xs12 sm6>
                <v-flex xs12>
                    <div class="text-xs-center ma-3">
                        <img src="/images/logo.png">
                    </div>
                </v-flex>
                <v-flex xs12>
                    <v-card>
                    <v-card-title primary-title>
                        <h3 class="headline mx-auto">{{ title + " " + appName }}</h3>
                    </v-card-title>
                    <v-card-actions>
                        <v-layout row>
                            <v-flex xs12>
                                <form @submit.prevent="register">
                                    <v-text-field
                                            label="Nama Lengkap"
                                            name="form.nama"
                                            v-model="form.nama"
                                            :error-messages="nama_errors"
                                            @blur="$v.form.nama.$touch()"
                                            @input="$v.form.nama.$touch()"
                                            required
                                    ></v-text-field>
                                    <v-menu
                                            ref="menu"
                                            v-model="menu_tanggal"
                                            :close-on-content-click="false"
                                            full-width
                                            max-width="290"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    :value="format_date(form.tgl_lahir)"
                                                    label="Tanggal Lahir"
                                                    readonly
                                                    v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                ref="picker"
                                                v-model="form.tgl_lahir"
                                                :max="max_tgl_lahir"
                                                @change="simpan_tanggal"
                                                locale="id-id"
                                        ></v-date-picker>
                                    </v-menu>
                                    <v-text-field
                                            label="Nomor Handphone"
                                            name="form.hp"
                                            v-model="form.hp"
                                            :error-messages="hp_errors"
                                            @blur="$v.form.hp.$touch()"
                                            @input="$v.form.hp.$touch()"
                                            required
                                    ></v-text-field>
                                    <v-text-field
                                            label="Email"
                                            name="form.email"
                                            v-model="form.email"
                                            :error-messages="email_errors"
                                            @blur="$v.form.email.$touch()"
                                            @input="$v.form.email.$touch()"
                                            required
                                    ></v-text-field>
                                    <v-text-field
                                            label="Password"
                                            name="form.password"
                                            v-model="form.password"
                                            :error-messages="password_errors"
                                            @blur="$v.form.password.$touch()"
                                            @input="$v.form.password.$touch()"
                                            :counter="20"
                                            min="6"
                                            :append-icon="password_visibility ? 'visibility' : 'visibility_off'"
                                            @click:append="() => (password_visibility = !password_visibility)"
                                            :type="password_visibility ? 'text' : 'password'"
                                            required
                                    ></v-text-field>

                                    <v-autocomplete
                                            label="Provinsi"
                                            v-model="form.provinsi_id"
                                            :loading="provinsi_id_loading"
                                            :items="provinsi_id_items"
                                            item-text="name"
                                            item-value="id"
                                            :error-messages="provinsi_id_errors"
                                            @change="$v.form.provinsi_id.$touch()"
                                            @blur="$v.form.provinsi_id.$touch()"
                                            clearable
                                            required
                                    ></v-autocomplete>

                                    <v-autocomplete
                                            label="Kabupaten/Kota"
                                            v-model="form.kabupaten_kota_id"
                                            :loading="kabupaten_kota_id_loading"
                                            :items="kabupaten_kota_id_items"
                                            item-text="name"
                                            item-value="id"
                                            :error-messages="kabupaten_kota_id_errors"
                                            @change="$v.form.kabupaten_kota_id.$touch()"
                                            @blur="$v.form.kabupaten_kota_id.$touch()"
                                            :search-input.sync="kabupaten_kota_id_search"
                                            clearable
                                            required
                                    ></v-autocomplete>

                                    <v-textarea
                                            label="Alamat"
                                            v-model="form.alamat"
                                    ></v-textarea>

                                    <v-layout row wrap align-center justify-center>
                                        <v-flex xs12 sm12 md5 ma-2>
                                            <v-btn name="simpan" type="submit" block color="primary" class="ma-0">Buat
                                                Akun
                                            </v-btn>
                                        </v-flex>
                                        <v-flex xs12 sm12 md5 ma-2>
                                            <v-btn to="/login" block color="primary" class="ma-0">Halaman Login</v-btn>
                                        </v-flex>
                                    </v-layout>
                                </form>
                            </v-flex>
                        </v-layout>
                    </v-card-actions>
                </v-card>
                </v-flex>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import UserAPI from "@/api/user";
    import WilayahAPI from "@/api/wilayah";
    import {validationMixin} from 'vuelidate';
    import {required} from 'vuelidate/lib/validators';
    import store from '@/store/index';
    import swal from "sweetalert2";
    import router from '@/router/index';
    import moment from 'moment';

    const {appName, appSubName, logo} = store.getters['config/data'];

    export default {
        metaInfo() {
            return {title: this.title}
        },

        mixins: [validationMixin],

        validations: {
            // validations
            form: {
                nama: {required},
                tgl_lahir: {required},
                hp: {required},
                email: {required},
                password: {required},
                provinsi_id: {required},
                kabupaten_kota_id: {required},
                alamat: {required},
            },
        },

        data: () => {
            let tanggal = new Date();
            tanggal.setFullYear(tanggal.getFullYear()-17);
            return {
                // data
                form: {
                    nama: null,
                    tgl_lahir: tanggal.toISOString().substring(0,10),
                    hp: null,
                    email: null,
                    password: null,
                    provinsi_id: null,
                    kabupaten_kota_id: null,
                    alamat: null,
                },
                menu_tanggal: false,
                title: "Pendaftaran Akun",
                appName,
                appSubName,
                password_visibility: false,
                logo,
                provinsi_id_items: [],
                provinsi_id_loading: false,
                kabupaten_kota_id_items: [],
                kabupaten_kota_id_loading: false,
                kabupaten_kota_id_search: null,
            }
        },

        watch: {
            menu_tanggal: function (val) {
                val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
            },
            'form.provinsi_id': function(new_val, old_val) {
                if(new_val) {
                    this.load_kabupaten_kota_id_items('');
                }
            },
            kabupaten_kota_id_search(val) {
                val && this.load_kabupaten_kota_id_items(val);
            },
        },

        computed: {
            max_tgl_lahir() {
                let tanggal = new Date();
                tanggal.setFullYear(tanggal.getFullYear()-17);
                return tanggal.toISOString();
            },
            nama_errors() {
                const errors = [];
                if (!this.$v.form.nama.$dirty) return errors;
                !this.$v.form.nama.required && errors.push('Nama harus diisi.');
                return errors;
            },

            tgl_lahir_errors() {
                const errors = [];
                if (!this.$v.form.tgl_lahir.$dirty) return errors;
                !this.$v.form.tgl_lahir.required && errors.push('Tanggal lahir harus diisi.');
                return errors;
            },

            hp_errors() {
                const errors = [];
                if (!this.$v.form.hp.$dirty) return errors;
                !this.$v.form.hp.required && errors.push('Handphone harus diisi.');
                return errors;
            },

            email_errors() {
                const errors = [];
                if (!this.$v.form.email.$dirty) return errors;
                !this.$v.form.email.required && errors.push('Email harus diisi.');
                return errors;
            },

            password_errors() {
                const errors = [];
                if (!this.$v.form.password.$dirty) return errors;
                !this.$v.form.password.required && errors.push('Password harus diisi.');
                return errors;
            },

            provinsi_id_errors() {
                const errors = [];
                if (!this.$v.form.provinsi_id.$dirty) return errors;
                !this.$v.form.provinsi_id.required && errors.push('Provinsi harus diisi.');
                return errors;
            },

            kabupaten_kota_id_errors() {
                const errors = [];
                if (!this.$v.form.kabupaten_kota_id.$dirty) return errors;
                !this.$v.form.kabupaten_kota_id.required && errors.push('Kabupaten/Kota harus diisi.');
                return errors;
            },
        },

        methods: {
            format_date(tanggal){
                return tanggal ? moment(tanggal).format('DD-MM-YYYY') : '';
            },
            simpan_tanggal (date) {
                this.$refs.menu.save(date)
            },
            load_provinsi_id_items(val = '') {
                let search_column = ["name"];

                let params = [];
                for(let idx in search_column) {
                    params.push(search_column[idx]+':'+val);
                }

                this.provinsi_id_loading = true;
                WilayahAPI.getProvinsiOptions(params)
                    .then(response => {
                        this.provinsi_id_items = response.data.results.data;
                        this.provinsi_id_loading = false;
                    }).catch(error => {
                });
            },

            load_kabupaten_kota_id_items(val = '') {
                let search_column = ["name"];

                let params = [];
                for(let idx in search_column) {
                    params.push(search_column[idx]+':'+val);
                }

                let filtered = {provinsi_id: this.form.provinsi_id};
                for(let idx in filtered) {
                    if(filtered[idx]) {
                        params.push(idx+':'+filtered[idx]);
                    }
                }

                this.kabupaten_kota_id_loading = true;
                WilayahAPI.getKabupatenKotaOptions(params)
                    .then(response => {
                        this.kabupaten_kota_id_items = response.data.results.data;
                        this.kabupaten_kota_id_loading = false;
                    }).catch(error => {
                });
            },
            async register() {
                this.$v.form.$touch();
                if (!this.$v.form.$invalid) {

                    this.$store.dispatch("loading/start");
                    // register
                    UserAPI.register(this.form).then(response => {
                        this.$store.dispatch("loading/stop");
                        swal.fire({
                            type: 'info',
                            title: response.data.results.message,
                            reverseButtons: false,
                            confirmButtonText: 'ok',
                        }).then(function () {
                            router.push({name: 'login'});
                        });
                    }).catch(error => {
                        this.$store.dispatch("loading/stop");
                    });
                }
            }
        },
        mounted() {
            this.load_provinsi_id_items();
        },
    }
</script>
